import Resource from '@/api/resource'
import request from '@/utils/request'
class BillingResource extends Resource {
  constructor() {
    super('api/v1/billings')
  }

  getCourseMemberList(query) {
    return request({
      url: '/' + this.uri + '/credit/member/lists',
      method: 'get',
      params: query
    })
  }

  createCredits(resource) {
    return request({
      url: '/' + this.uri + '/credit/member/one',
      method: 'post',
      data: resource
    })
  }

  getPayableList(query) {
    return request({
      url: '/' + this.uri + '/payable/lists',
      method: 'get',
      params: query
    })
  }
}

export { BillingResource as default }
